import React from 'react';

import { TagContainer } from './styles';

const Tag = ({ children, ...rest }) => {
  return <TagContainer {...rest}>{children}</TagContainer>;
};

export default Tag;
